<div class="header">
  <div *ngIf="displayInTranslationPage">
    <md-icon>dashboard</md-icon>
    <h3>Dashboard</h3>
  </div>

  <div *ngIf="!displayInTranslationPage">
    <md-icon>translate</md-icon>
    <h3>Translate</h3>
  </div>
</div>
<div class="filters">
  <md-select
    *ngIf="!displayInTranslationPage"
    [(ngModel)]="translations.filteredTranslationTypes"
    [multiple]="true"
    #translationTypesSelect="ngModel"
    placeholder="Translation Types"
    (change)="translationTypeChanged($event)"
  >
    <md-option disabled="disabled" style="margin-left: -36px; color: black">
      <md-checkbox
        name="selectAll"
        style="margin-left: 4px"
        color="accent"
        (change)="
          selectAllTranslationTypes(
            translationTypesSelect,
            translationTypes,
            $event
          )
        "
        [checked]="alltranslationTypesSelected()"
        >Select All</md-checkbox
      >
    </md-option>
    <hr />
    <md-option
      *ngFor="let translationType of translationTypes"
      [value]="translationType"
    >
      {{ translationType.value }}
    </md-option>
  </md-select>
</div>

<h3 class="title">Sport</h3>
<div class="container">
  <div *ngFor="let chart of charts">
    <div *ngIf="chart.isDisplayed && chart.isSportiveClassification">
      <h4 class="title" [routerLink]="['', 'translate', chart.id]">
        {{ chart.title }}
      </h4>
      <div style="display: block; cursor: pointer">
        <canvas
          baseChart
          [data]="chart.data"
          [labels]="chart.labels"
          [chartType]="chart.type"
          [colors]="colors"
          (chartClick)="chartClick($event, chart)"
          [legend]="true"
        ></canvas>
      </div>
      <i>{{ chart.percentTranslated }} % translated</i>
    </div>
  </div>
</div>

<h3 class="title">Non Sport</h3>
<div class="container">
  <div *ngFor="let chart of charts">
    <div
      *ngIf="
        chart.isDisplayed &&
        !chart.isMetadatasClassification && !chart.isSportiveClassification
      "
    >
      <h4 class="title" [routerLink]="['', 'translate', chart.id]">
        {{ chart.title }}
      </h4>
      <div style="display: block; cursor: pointer">
        <canvas
          baseChart
          [data]="chart.data"
          [labels]="chart.labels"
          [chartType]="chart.type"
          [colors]="colors"
          (chartClick)="chartClick($event, chart)"
          [legend]="true"
        ></canvas>
      </div>
      <i>{{ chart.percentTranslated }} % translated</i>
    </div>
  </div>
</div>

<h3 class="title">Metadatas</h3>
<div class="container">
  <div *ngFor="let chart of charts">
    <div *ngIf="chart.isDisplayed && chart.isMetadatasClassification">
      <h4 class="title" [routerLink]="['', 'translate', chart.id]">
        {{ chart.title }}
      </h4>
      <div style="display: block; cursor: pointer">
        <canvas
          baseChart
          [data]="chart.data"
          [labels]="chart.labels"
          [chartType]="chart.type"
          [colors]="colors"
          (chartClick)="chartClick($event, chart)"
          [legend]="true"
        ></canvas>
      </div>
      <i>{{ chart.percentTranslated }} % translated</i>
    </div>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/pages/translate/translations-dashboard/translations-dashboard.component.html